/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {BehaviorSubject, Observable} from 'rxjs';
import {CartProduct} from '../interfaces/CartProduct';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class CartEventService {

  private totalCost$ = new BehaviorSubject<number>(0);
  private totalCostWithoutDiscount$ = new BehaviorSubject<number>(0);
  private discountTotalCost$ = new BehaviorSubject<number>(0);
  private totalAmount$ = new BehaviorSubject<number>(0);
  private uniqueAmount$ = new BehaviorSubject<number>(0);
  private amount$ = new BehaviorSubject<number>(0);
  private totalVolume$ = new BehaviorSubject<number>(0);
  private totalWeight$ = new BehaviorSubject<number>(0);
  private cart$ = new BehaviorSubject<CartProduct[]>([]);
  private cartProduct$ = new BehaviorSubject<CartProduct>(null);
  private replaceCartProduct$ = new BehaviorSubject<boolean>(false);

  getTotalCost(): Observable<number> {
    return this.totalCost$.asObservable();
  }

  getTotalCostWithoutDiscount(): Observable<number> {
    return this.totalCostWithoutDiscount$.asObservable();
  }

  getDiscountTotalCost(): Observable<number> {
    return this.discountTotalCost$.asObservable();
  }

  getTotalAmount(): Observable<number> {
    return this.totalAmount$.asObservable();
  }

  getUniqueAmount(): Observable<number> {
    return this.uniqueAmount$.asObservable();
  }

  getTotalVolume(): Observable<number> {
    return this.totalVolume$.asObservable();
  }

  getTotalWeight(): Observable<number> {
    return this.totalWeight$.asObservable();
  }

  getCart(): Observable<CartProduct[]> {
    return this.cart$.asObservable();
  }

  getCartProduct(): Observable<CartProduct> {
    return this.cartProduct$.asObservable();
  }

  getAmount(): Observable<number> {
    return this.amount$.asObservable();
  }

  getReplaceCartProduct(): Observable<boolean> {
    return this.replaceCartProduct$.asObservable();
  }

  nextTotalCost(value: number) {
    this.totalCost$.next(value);
  }

  nextTotalCostWithoutDiscount(value: number) {
    this.totalCostWithoutDiscount$.next(value);
  }

  nextDiscountTotalCost(value: number) {
    this.discountTotalCost$.next(value);
  }

  nextTotalAmount(value: number) {
    this.totalAmount$.next(value);
  }

  nextUniqueAmount(value: number) {
    this.uniqueAmount$.next(value);
  }

  nextTotalVolume(value: number) {
    this.totalVolume$.next(value);
  }

  nextTotalWeight(value: number) {
    this.totalWeight$.next(value);
  }

  nextCart(value: CartProduct[]) {
    this.cart$.next(value);
  }

  nextCartProduct(value: CartProduct) {
    this.cartProduct$.next(value);
  }

  nextAmount(value: number) {
    this.amount$.next(value);
  }

  nextReplaceCartProduct() {
    this.replaceCartProduct$.next(true);
  }
}
